// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__eDtEt","Tab":"Tabs_Tab__WVmaC","active":"Tabs_active__2sVAI"};